<div class="content">
  <h1 class="large">Сменить пароль</h1>

  @if (error) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Произошла ошибка: {{ error }}
    </div>
  }
  @if (successMessage) {
    <div class="success-message">
      {{ successMessage }}
    </div>
  }
  <form #f="ngForm" (ngSubmit)="save(f)">
    <!-- старый пароль -->
    <div>
      <input type="password"
             name="oldPassword"
             placeholder="Старый пароль"
             class="form-input"
             required
             [(ngModel)]="oldPassword"
             #oldPwd="ngModel">

      @if (oldPwd.invalid && (oldPwd.touched || oldPwd.dirty)) {
        <div class="error">
          Введите старый пароль
        </div>
      }
    </div>

    <!-- новый пароль -->
    <div>
      <input type="password"
             name="newPassword"
             placeholder="Новый пароль"
             class="form-input"
             required
             appPasswordValidationDirective
             [(ngModel)]="newPassword"
             #newPwd="ngModel">

      @if (newPwd.invalid && (newPwd.touched || newPwd.dirty)) {
        <div class="error">
          Пароль должен быть не меньше 8 символов, содержать символы в разном регистре, спецсимволы и цифры
        </div>
      }
    </div>

    <!-- подтверждение -->
    <div>
      <input type="password"
             name="confirmation"
             placeholder="Подтверждение"
             class="form-input"
             required
             [(ngModel)]="confirmation"
             #conf="ngModel">

      @if (conf.invalid && (conf.touched || conf.dirty)) {
        <div class="error">
          Введите подтверждение пароля
        </div>
      }
      @if (passwordsMismatch && (conf.touched || conf.dirty)) {
        <div class="error">
          Пароль и подтверждение не совпадают
        </div>
      }
    </div>

    <!-- кнопка -->
    <button type="submit"
            class="primary"
            [disabled]="f.invalid || passwordsMismatch || loading || !!successMessage">
      Сохранить
    </button>
  </form>
</div>
